import { RootState } from '../../../store';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { LoginFormType } from '../schemas/loginSchema';
import { AUTH_API_URLS } from '../constants';
import { LoginResponse, LogoutResponse } from '../../../types/authTypes';

const baseAuthQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_UAT_BASE_AUTH_URL,
  prepareHeaders: (headers, { getState }) => {
    const state = getState() as RootState; // Explicitly typing the state
    const token = state.auth?.accessToken; // Accessing the token from the state
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    // console.log('base_url', process.env.BASE_AUTH_URL);
    //custom headers
    headers.set('Content-type', 'application/json');
    headers.set('Source-App', 'DEV'); //should be QdosV5
    headers.set('Source-Remote-Ip', '127.0.0.1');
    headers.set('Source-Local-Ip', '127.0.0.1');
    return headers;
  },
});

export const authApiSlice = createApi({
  reducerPath: 'authApi',
  baseQuery: baseAuthQuery,
  endpoints: (builder) => {
    return {
      login: builder.mutation<LoginResponse, LoginFormType>({
        query: (user) => ({
          url: AUTH_API_URLS.LOGIN,
          method: 'POST',
          body: { ...user },
        }),
      }),
      refreshToken: builder.mutation<
        LoginResponse,
        { refreshToken: string; accessToken: string }
      >({
        query: (data) => ({
          url: AUTH_API_URLS.REFRESH_TOKEN,
          method: 'POST',
          body: {
            'refresh-token': data.refreshToken,
            'access-token': data.accessToken,
          },
        }),
      }),
      logout: builder.mutation<LogoutResponse, {}>({
        query: (data) => ({
          url: AUTH_API_URLS.LOGOUT,
          method: 'POST',
        }),
      }),
    };
  },
});

export const { useLoginMutation, useRefreshTokenMutation, useLogoutMutation } =
  authApiSlice;
